<script>
import {
  getCampaign,
  getSegments,
  getTemplates,
  updateCampaign
} from "@/api/campaigns";
import { getEmailSenders } from "@/api/accounts";
import swal from "sweetalert";
export default {
  name: "email-campaign",
  props: ["show", "locations", "campaign_id"],
  data() {
    return {
      form: {
        name: "",
        subject: "",
        subscriber_list_id: null,
        template_id: null,
        sender_name: "",
        sender_email: "",
        personalization: null,
        segment_id: null
      },
      personalizationOptions: [
        { value: null, text: "Insert Personalization" },
        { value: "name", text: "Name" }
      ],
      snackbar: false,
      text: "Loading campaigns...",
      timeout: 2000,
      campaign: null,
      segments: [],
      templates: [],
      emails: []
    };
  },
  async mounted() {
    // console.log("this.campaign_id", this.campaign_id);
    this.setCampaign();
    this.setSegments();
    this.setTemplates();
    this.setEmailSenders();
  },
  computed: {
    visible() {
      return this.show;
    },
    templatesOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.templates.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    },
    emailOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.emails.map(list => {
          return {
            value: list.id,
            text: `${list.email}`
          };
        })
      ];
    },
    segmentsOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.segments.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    }
  },
  methods: {
    async setCampaign() {
      let response = await getCampaign(this.campaign_id);
      // console.log("response", response);
      if (response && response.id) {
        this.form.name = response.name;
        this.form.subject =
          response && response.subject ? response.subject : "";
        this.form.sender_name =
          response && response.sender_name ? response.sender_name : "";
        this.form.sender_email =
          response && response.sender_email ? response.sender_email : "";
        this.form.template_id =
          response && response.template ? response.template.id : null;
        this.form.subscriber_list_id =
          response && response.subscriber_list
            ? response.subscriber_list
            : null;
        this.form.segment_id =
          response && response.segment_id ? response.segment_id : null;
      }
    },
    async setSegments() {
      let response = null;
      response = await getSegments();
      if (response && response.length > 0) {
        this.segments = response;
      } else {
        this.snackbar = true;
        this.text = "Fetching of segment list. Returns empty response";
      }
    },
    async setTemplates() {
      let response = null;
      response = await getTemplates();
      if (response && response.length > 0) {
        this.templates = response;
      } else {
        this.snackbar = true;
        this.text = "Fetching of templates. Returns empty response";
      }
    },
    async setEmailSenders() {
      // Fetch email senders
      let response = null;
      response = await getEmailSenders();
      if (response && response.length > 0) {
        this.emails = response;
      } else {
        this.snackbar = true;
        this.text = "Fetching of email senders. Returns empty response";
      }
    },
    addTemplate() {
      this.$router.push(`/templates`);
    },
    async onSubmit() {
      const payload = JSON.parse(JSON.stringify(this.form));
      // console.log("payload", payload);
      const response = await updateCampaign(this.campaign_id, payload);
      // console.log("response", response);
      if (response) {
        swal("Campaign updated.");
      } else {
        swal("There's an issue", "Error in updating a campaign");
      }
      await this.$store.dispatch("getCampaignList");
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<template>
  <v-dialog v-model="visible" persistent scrollable width="40%">
    <v-card flat>
      <v-card-text>
        <v-form
          method="POST"
          accept-charset="UTF-8"
          enctype="multipart/form-data"
          id="email-campaign-form"
        >
          <v-container>
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-template"
                  label="Template:"
                  label-for="select-template"
                >
                  <b-form-select
                    id="select-template"
                    v-model="form.template_id"
                    :options="templatesOptions"
                    required
                  ></b-form-select>
                  <b-form-text>
                    <a href="#" @click.prevent="addTemplate">Add Template</a>
                  </b-form-text>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="input-group-campaign-name"
                  label="Campaign Name:"
                  label-for="input-campaign-name"
                >
                  <b-form-input
                    id="input-campaign-name"
                    v-model="form.name"
                    type="text"
                    required
                    placeholder="Campaign name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="input-group-from-name"
                  label="Who is it from:"
                  label-for="input-from-name"
                >
                  <b-form-input
                    id="input-from-name"
                    v-model="form.sender_name"
                    type="text"
                    required
                    placeholder="Who is it from"
                  ></b-form-input>
                  <b-form-text id="input-from-name-help">
                    This will be displayed in the From field of your recipient's
                    email client.
                  </b-form-text>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  id="input-group-from-email"
                  label="From Email:"
                  label-for="input-from-email"
                >
                  <b-form-select
                    id="input-from-email"
                    v-model="form.sender_email"
                    :options="emailOptions"
                    required
                  ></b-form-select>
                  <b-form-text id="input-from-name-help">
                    We recommend using your own email and name. Avoid emails like
                    no-reply@company.com.
                  </b-form-text>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group
              id="input-group-subject"
              label="Subject"
              label-for="input-subject"
            >
              <b-row>
                <b-col>
                  <div>
                    <b-input-group>
                      <b-form-input
                        id="input-subject"
                        v-model="form.subject"
                        type="text"
                        required
                        placeholder="Subject"
                      ></b-form-input>
                      <template #append>
                        <b-form-select
                          id="select-personalization"
                          v-model="form.personalization"
                          :options="personalizationOptions"
                          class="bg-secondary"
                          @change="onChange($event)"
                        ></b-form-select>
                      </template>
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group
              id="input-group-subscriber-list"
              label="Segment List:"
              label-for="select-segment_id"
            >
              <b-form-select
                id="select-segment_id"
                v-model="form.segment_id"
                :options="segmentsOptions"
                required
              ></b-form-select>
            </b-form-group>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="mt-20 p-5">
        <v-spacer></v-spacer>
        <v-btn class="mr-4" depressed tile @click="close">
          Close
        </v-btn>
        <v-btn class="mr-4" @click="onSubmit" depressed color="primary">
          Submit
        </v-btn>
      </v-card-actions>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>
